
import { ETextColor } from '../../Projects/enums';
import { ELayoutActions } from './enums';

export const setFooterVisibility = (visibility: boolean = true) => ({
    type: ELayoutActions.SET_FOOTER_VISIBILITY,
    payload: visibility,
});

export const setHeaderColor = (color: ETextColor) => ({
    type: ELayoutActions.SET_HEADER_COLOR,
    payload: color,
});
